import {
  baseRouteMakerForSuperAdmin,
  routes,
} from "../../../constants/routeConsts";
import { t } from "i18next";

export const useUserManagementMenuUtils = () => {
  const tempMenuGroup = [];

  /* menuItemUser */
  const menuItemUser = {
    id: "user",
    title: t("Modules.chatConversation.users"),
    url: baseRouteMakerForSuperAdmin(routes.USER),
  };
  tempMenuGroup.push(menuItemUser);
  /* menuItemUser */

  /* Service provider */
  const menuItemProvider = {
    id: "provider",
    title: t("Modules.chatConversation.serviceProviders"),
    url: baseRouteMakerForSuperAdmin(routes.PROVIDER),
  };
  tempMenuGroup.push(menuItemProvider);
  /* Service provider */

  /* Fine Config */
  const menuItemFineConfig = {
    id: "fine-config",
    title: t("Modules.chatConversation.fineConfig"),
    url: baseRouteMakerForSuperAdmin(routes.FINE_CONFIG),
  };
  tempMenuGroup.push(menuItemFineConfig);
  /* Fine Config */

  /* Fine Transaction History */
  const menuItemFineTransactionHistory = {
    id: "fine-transaction-history",
    title: t("Modules.chatConversation.fineTransactionHistory"),
    url: baseRouteMakerForSuperAdmin(routes.FINE_TANSACTION_HISTORY),
  };
  tempMenuGroup.push(menuItemFineTransactionHistory);
  /* Fine Transaction History */

  return tempMenuGroup;
};
